module.exports = __webpack_public_path__ + "static/media/envelope-solid.3fdf7e52.svg";